
import * as _ from 'lodash';
import { IApiUrls, Settings, IApiMethod } from '../models/utilitiesModel';
import * as CryptoJS from 'crypto-js';

let apiurlsData: IApiUrls[] = [];
let appsetting: Settings;
const getApiServiceUrlByComponentAndMethod = (compName, methodName) => {
    let iapiMethods = _.pick(_.filter(apiurlsData, { component: compName })[0], ['methods']);
    let iapiMethod1 = (_.filter(iapiMethods['methods'], { name: methodName })[0]) as IApiMethod;
    let iapiMethod = { name: iapiMethod1.name, type: iapiMethod1.type, url: iapiMethod1.url } as IApiMethod
    return iapiMethod;
}
const setApiUrlsData = (data) => {
    apiurlsData = data;
}
const setAppsetting = (data: Settings) => {
    appsetting = data;
}
const getAppsetting = () => {
    return appsetting;
}
const gettranId = (modulesCode?: string) => {
    return modulesCode ? `${modulesCode}${Math.random().toString(36).slice(7)}` : (Math.random().toString(36).slice(7)) + '';
}
const getIntervalCall = () => {
    return appsetting.intervalCall;
}
const getSessionReset = () => {
    return appsetting.sessionReset;
}
const getShowMessageTime = () => {
    return appsetting.showMessageTime;
}
const getDateTimeInterval = () => {
    return appsetting.dateTimeInterval;
}

const getReaderRetriveInterval = () => {
    return appsetting.readerRetriveInterval;
}
const getReaderUrl = () => {
    return appsetting.readerUrl;
}
const getversionCheckInterval = (): number => {
    return appsetting.versionCheckInterval;
}
const getDoctorScheduleStartTime = (): number => {
    return appsetting.doctorScheduleTimeStart;
}
const getDoctorScheduleEndTime = (): number => {
    return appsetting.doctorScheduleTimeEnd;
}
const getDoctorScheduleIntervelInMinutes = (): number => {
    return appsetting.doctorScheduleIntervelInMinutes;
}
const getIdleSelectionTimer = (): number => {
    return appsetting.idleSelectionTime;
}

const getStaticAppoinments = (): any =>{
    return appsetting.staticAppointment
}
const getExistQRString = (): any =>{
    return appsetting.existQRString
}
const getTokenQRString = (): any =>{
    return appsetting.tokenQRString
}
export const parseJsonData = (value) => {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return ''
    }
}
 
export const getJsonStringfy = (data) => {
    try {
        return JSON.stringify(data)
    } catch (err) {
        console.log(err);
        return ''
    }
}
const encryptSecretKey = 'Gr3@tW@t3rS@lt@1B2c3D4e5F6g7H8';

export const decryptData = (e, s = "") => {
    try {
        let t = CryptoJS.AES.decrypt(e, s || encryptSecretKey);
        return t.toString() ? JSON.parse(t.toString(CryptoJS.enc.Utf8)) : e
    } catch (t) {
        console.log(t)
    }
}
export const encryptData = (e, s = "") => {
    try {
        return CryptoJS.AES.encrypt(JSON.stringify(e), s || encryptSecretKey).toString()
    } catch (t) {
        console.log("error=>", t)
    }
}


export { getReaderRetriveInterval, getReaderUrl, getDateTimeInterval, getSessionReset, getShowMessageTime, setAppsetting, getAppsetting, setApiUrlsData, getApiServiceUrlByComponentAndMethod, getIntervalCall, gettranId, getversionCheckInterval, getIdleSelectionTimer,getDoctorScheduleStartTime,getDoctorScheduleEndTime,getDoctorScheduleIntervelInMinutes,getStaticAppoinments,getExistQRString,getTokenQRString }
